import React from 'react'
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import classNames from 'classnames'

// components
import NTMButton from 'components/Buttons/NTMButton'

// content
import AnalisiDati from './Content/AnalisiDati'
import Dss from './Content/Dss'
import Gelata from './Content/Gelata'
import Irrigazione from './Content/Irrigazione'
import Magico from './Content/Magico'
import Manutenzione, { Centralina } from './Content/Manutenzione'
import Medie from './Content/Medie'
import Agrumi, { Oidio as OidioAgrumi } from './Content/Agrumi'
import Grano, { Septoria } from './Content/Grano'
import Melo, { Ticchiolatura } from './Content/Melo'
import Olivo, { Cicloconio, Lebbra, Rogna } from './Content/Olivo'
import Vite, { Botrite, Oidio as OidioVite, Peronospora } from './Content/Vite'

// constants
import TOPICS, { names } from './_topics'
import style from './guide.module.scss'


let findTopicByName = name => TOPICS.find(t => t.name === name)


let ContentProvider = ({ topic }) => {
    switch (topic) {
        case names.ANALISI_DATI: return <AnalisiDati />
        case names.CENTRALINA: return <Centralina />
        case names.DSS: return <Dss />
        case names.GELATA: return <Gelata />
        case names.IRRIGAZIONE: return <Irrigazione />
        case names.MAGICO: return <Magico />
        case names.MEDIE: return <Medie />
        case names.MANUTENZIONE: return <Manutenzione />
        case names.AGRUMI: return <Agrumi />
        case names.AGRUMI_OIDIO: return <OidioAgrumi />
        case names.GRANO: return <Grano />
        case names.GRANO_SEPTORIA: return <Septoria />
        case names.MELO: return <Melo />
        case names.MELO_TICCHIOLATURA: return <Ticchiolatura />
        case names.OLIVO: return <Olivo />
        case names.OLIVO_CICLOCONIO: return <Cicloconio />
        case names.OLIVO_LEBBRA: return <Lebbra />
        case names.OLIVO_ROGNA: return <Rogna />
        case names.VITE: return <Vite />
        case names.VITE_BOTRITE: return <Botrite />
        case names.VITE_OIDIO: return <OidioVite />
        case names.VITE_PERONOSPORA: return <Peronospora />
        default: return null
    }
}

let GuideNavBtn = ({ topic, type }) => {
    let btn
    switch (type) {
        case 'prev': btn = <NTMButton primary>{"< Precedente"}</NTMButton>; break
        case 'next': btn = <NTMButton primary>{"Successivo >"}</NTMButton>; break
        case 'parent': btn = <NTMButton>{"Su"}</NTMButton>; break
        default: btn = null; break
    }
    return (topic) ? (
        <Link to={`/guide/${topic}`}>{btn}</Link>
    ) : (
        <div style={{ visibility: 'hidden' }}>{btn}</div>
    )
}

let GuideNavigator = ({ topic }) =>
    <nav className={classNames(style.guideNav)} >
        <GuideNavBtn topic={topic.prev} type='prev' />
        <GuideNavBtn topic={topic.parent} type='parent' />
        <GuideNavBtn topic={topic.next} type='next' />
    </nav>


const GuidePage = () => {
    let navigate = useNavigate();
    let { topic } = useParams()
    let topicObj = findTopicByName(topic)

    if (!topicObj) return <Navigate to="/404" />

    return (
        <div>
            <div className={classNames(style.guideContent)}>
                <ContentProvider topic={topic} />
            </div>
            {/* <GuideNavigator topic={topicObj} /> */}
            <nav className={classNames(style.guideNav)} >
                <NTMButton onClick={() => navigate(-1)}>{"Indietro"}</NTMButton>
            </nav>
        </div>
    )
}

export default GuidePage